module.exports = __webpack_public_path__ + "img/vip_card_bg-ddc6fc5c.e37a88f8.png";